import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";

export default function PartnerDoctorInfoList({ fetchTrigger }) {
  const { user } = useAuth();

  const navigate = useNavigate();

  const location = useLocation();

  const [doctor, setDoctor] = useState({
    name: "",
    doctorname: "",
    linkedCustomerToken: "",
    linkedCustomerName: "",
    description0: "",
    address: "",
    contactPerson: "",
    email: "",
    phone: "",
    loginEmail: "",
    status: "",
  });

  useEffect(() => {
    if (location.state?.doctorToken == null) {
      navigate("/");
    } else {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            backendlink + "partner/getdoctorprofile",
            {
              usertoken: user.userToken,
              doctortoken: location.state.doctorToken,
            },
            {
              headers: {
                token: user.token,
              },
            }
          );

          if (response.data.errorno === 0) {
            const outputArray = response.data.result.map((item) => {
              var statusString =
                item.isEnabled === true ? "Active" : "Inactive";

              setDoctor({
                id: item.id,
                name: item.name,
                address: item.companyaddress,
                linkedCustomerToken: item.parentToken,
                linkedCustomerName: item.linkedcustomer,
                description: item.description0,
                contactPerson: item.contactperson,
                email: item.email,
                phone: item.phone,
                loginEmail: item.username,
                status: statusString,
              });
            });
          } else {
            alert(response.data.errmessage);
          }
        } catch (error) {
          alert(error);
        }
      };

      fetchData();
    }
  }, [user, fetchTrigger]);

  return (
    <div className="card-container">
      <div className="card">
        <h2>Doctor Information</h2>
        <div className="user-info">
          <div className="user-info-item">
            <span className="label">Account ID (Auto Generated):</span>
            <span className="value">{doctor.id}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Doctor Name:</span>
            <span className="value">{doctor.name}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Linked Organization:</span>
            <span className="value">{doctor.linkedCustomerName}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Description:</span>
            <span className="value">{doctor.description}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Address:</span>
            <span className="value">{doctor.address}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Status:</span>
            <span className="value">{doctor.status}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Login Email:</span>
            <span className="value">{doctor.loginEmail}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Person:</span>
            <span className="value">{doctor.contactPerson}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Number:</span>
            <span className="value">{doctor.phone}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Email:</span>
            <span className="value">{doctor.email}</span>
          </div>
          {/* Add more fields as needed */}
        </div>
      </div>
    </div>
  );
}
